import React from 'react';
import { Marker } from 'react-map-gl';
import { Box } from '@material-ui/core';

const SitesMarkers = ({ sites, setSiteImage }) => {
  return sites.map((site, i) => (
    <Box key={`site-${i}`} onClick={() => setSiteImage(site.properties.image)}>
      <Marker
        key={i}
        longitude={site.geometry.coordinates[0]}
        latitude={site.geometry.coordinates[1]}
        className={site.properties.RR ? 'robin' : 'no-robin'}
      >
        <Box width={500} position={'absolute'} style={{ bottom: 28 }}>
          <div
            dangerouslySetInnerHTML={{ __html: site.properties.nameHTML }}
          ></div>
        </Box>
      </Marker>
    </Box>
  ));
};

export default SitesMarkers;
